export const categoryData = [
  {
    id: 'yule',
    name: '娱乐',
    icon: 'ri-movie-2-line',
    description: '热门影视、综艺节目、明星动态、音乐排行，精彩娱乐内容一网打尽',
    articleCount: 128,
    color: 'accent',
  },
  {
    id: 'zixun',
    name: '资讯',
    icon: 'ri-newspaper-line',
    description: '国内外时事热点、社会民生、政策解读，第一时间获取最新资讯',
    articleCount: 256,
    color: 'primary',
  },
  {
    id: 'keji',
    name: '科技',
    icon: 'ri-smartphone-line',
    description: '前沿科技动态、数码产品评测、互联网行业观察、AI发展趋势',
    articleCount: 189,
    color: 'secondary',
  },
  {
    id: 'shenghuo',
    name: '生活',
    icon: 'ri-heart-pulse-line',
    description: '美食旅游、家居装修、育儿亲子、情感心理，发现生活之美',
    articleCount: 145,
    color: 'accent',
  },
  {
    id: 'jiaoyu',
    name: '教育',
    icon: 'ri-book-open-line',
    description: '考试资讯、学习方法、留学规划、职业培训，助力个人成长',
    articleCount: 112,
    color: 'primary',
  },
  {
    id: 'jiankang',
    name: '健康',
    icon: 'ri-mental-health-line',
    description: '养生保健、运动健身、疾病预防、心理健康，守护身心健康',
    articleCount: 98,
    color: 'secondary',
  },
  {
    id: 'caijing',
    name: '财经',
    icon: 'ri-funds-line',
    description: '股票基金、理财投资、商业分析、经济趋势，把握财富机遇',
    articleCount: 167,
    color: 'accent',
  },
  {
    id: 'lvyou',
    name: '旅游',
    icon: 'ri-earth-line',
    description: '景点攻略、旅行日记、酒店民宿、特色美食，探索世界之美',
    articleCount: 134,
    color: 'primary',
  },
];

export function getCategoryBySlug(slug: string) {
  return categoryData.find((c) => c.id === slug) || null;
}